import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { campaignsApi, type Campaign } from './campaignsApi';
import type { GoogleProposalResult, GoogleProposals } from './googleProposals';

export function useGenerateGoogleProposals(campaign: Campaign, init?: RequestInit) {
  const queryClient = useQueryClient();
  const [latest, setLatest] = useState<GoogleProposalResult>();
  useEffect(() => { setLatest(undefined); }, [campaign.id, campaign.google_headlines, campaign.google_descriptions, campaign.google_keywords]);
  function refresh(result: GoogleProposalResult) {
    setLatest(result);
    queryClient.invalidateQueries({ queryKey: ['campaigns'] });
    queryClient.invalidateQueries({ queryKey: ['campaign', campaign.id] });
  }
  const mutation = useMutation({
    mutationFn: () => campaignsApi.generateGoogleProposals(campaign.id, init),
    onSuccess: refresh,
  });
  const saveMutation = useMutation({
    mutationFn: (proposals: GoogleProposals) => campaignsApi.updateGoogleProposals(campaign.id, proposals, init),
    onSuccess: refresh,
  });
  const result = latest?.campaignId === campaign.id ? latest.google_ads : undefined;
  return {
    generate: () => mutation.mutate(),
    generating: mutation.isPending,
    error: mutation.error?.message,
    generated: Boolean(result),
    save: (proposals: GoogleProposals) => saveMutation.mutateAsync(proposals),
    saving: saveMutation.isPending,
    saveError: saveMutation.error?.message,
    campaign: result ? { ...campaign, google_headlines: result.headlines,
      google_descriptions: result.descriptions, google_keywords: result.keywords } : campaign,
  };
}
